import { Settings } from 'hooks/useGetSettings';

export enum QueryKeys {
  Config = 'Config',
  Forecasts = 'Forecasts',
  LocationHistory = 'LocationHistory',
  Locations = 'Locations',
  Settings = 'Settings',
  Tokens = 'Tokens',
}

export enum StorageKeys {
  LocationHistory = 'leanstacks.weather.locations',
  Settings = 'leanstacks.weather.settings',
}

export enum DateFormats {
  DATE = 'MM/DD/YYYY',
  DAY_OF_WEEK = 'dddd',
  HOURS_AND_MINUTES = 'H[h] mm[m]',
  TIME = 'h:mma',
  TIMESTAMP_SHORT = 'h:mma ddd MMM D',
  TIMESTAMP = 'dddd MMMM D [at] h:mma',
}

export enum UnitsOfMeasurement {
  Imperial = 'imperial',
  Metric = 'metric',
}

export enum UnitDisplay {
  Long = 'long',
  Narrow = 'narrow',
  Short = 'short',
}

export enum Units {
  Celsius = 'celsius',
  Centimeter = 'centimeter',
  Fahrenheit = 'fahrenheit',
  Inch = 'inch',
  Kilometer = 'kilometer',
  KilometerPerHour = 'kilometer-per-hour',
  Mile = 'mile',
  MilePerHour = 'mile-per-hour',
  Millibar = 'millibar',
  Millimeter = 'millimeter',
  Percent = 'percent',
}

export const DEFAULT_SETTINGS: Settings = {
  theme: 'light',
  units: UnitsOfMeasurement.Imperial,
};
